module.exports = __webpack_public_path__ + "media/images/PoweredByLogo_53x20-e2afd26d22fc8c916782db48f885db18.png";